/**
 * created by hezq on 2019-10-24
 *
 * description： 常量集合
 *
 */

import common from 'consts/common';
import auths from 'consts/auths';
import store from 'consts/store';

const consts = {
	COMMON: common,
	AUTHS: auths,
	STORE: store
};

export default consts;


// WEBPACK FOOTER //
// ./src/consts/index.js